var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1931_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 -0.000976562C11.0145 -0.000976562 9 2.01352 9 4.49902C9 6.98452 11.0145 8.99902 13.5 8.99902C15.9855 8.99902 18 6.98452 18 4.49902C18 2.01352 15.9855 -0.000976562 13.5 -0.000976562ZM15.5303 5.46877C15.8235 5.76202 15.8235 6.23602 15.5303 6.52927C15.384 6.67552 15.192 6.74902 15 6.74902C14.808 6.74902 14.616 6.67552 14.4697 6.52927L13.5 5.55952L12.5303 6.52927C12.384 6.67552 12.192 6.74902 12 6.74902C11.808 6.74902 11.616 6.67552 11.4698 6.52927C11.1765 6.23602 11.1765 5.76202 11.4698 5.46877L12.4395 4.49902L11.4698 3.52927C11.1765 3.23602 11.1765 2.76202 11.4698 2.46877C11.763 2.17552 12.237 2.17552 12.5303 2.46877L13.5 3.43852L14.4697 2.46877C14.763 2.17552 15.237 2.17552 15.5303 2.46877C15.8235 2.76202 15.8235 3.23602 15.5303 3.52927L14.5605 4.49902L15.5303 5.46877ZM11.172 10.0288L10.5 10.7848V17.2498C10.5 17.534 10.3395 17.7935 10.0852 17.921C9.97875 17.9743 9.864 17.9998 9.75 17.9998C9.591 17.9998 9.43275 17.9488 9.3 17.8498L6.3 15.5998C6.111 15.4588 6 15.236 6 14.9998V10.7848L0.738 4.86502C0.26175 4.32877 0 3.63952 0 2.92252C0 1.31077 1.31175 -0.000976562 2.9235 -0.000976562H9.5445C8.29425 1.09927 7.5 2.70652 7.5 4.49902C7.5 6.98227 9.0165 9.11752 11.172 10.0288Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1931_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 -0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilter);
export default __webpack_public_path__ + "static/media/ClearFilter.c6bb16e960c4443aa5599596ba05ca54.svg";
export { ForwardRef as ReactComponent };